module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<ul class=\"nav nav-tabs nav-justified\">\r\n    <li id='settings-tab' class=\"active\"><a href=\"#settings\" name=\"aSettings\" data-toggle=\"tab\" aria-expanded=\"true\">Settings</a></li>\r\n    <li class=\"\"><a href=\"#propStyle\" data-toggle=\"tab\" name=\"aPropStyle\" aria-expanded=\"false\">Style</a></li>\r\n    <li class=\"\"><a href=\"#access\" data-toggle=\"tab\" name=\"aAccess\" aria-expanded=\"false\">Access</a></li>\r\n</ul>\r\n\r\n<div  class=\"tab-content\">\r\n    <div class=\"tab-pane fade active in\" id=\"settings\" name=\"settings\">\r\n\r\n    </div>\r\n    <div class=\"tab-pane fade\" id=\"propStyle\" name=\"propStyle\">\r\n        <p>Content here</p>\r\n    </div>\r\n    <div class=\"tab-pane fade\" id=\"access\" name=\"access\">\r\n        <p>Content here</p>\r\n    </div>\r\n</div>")
  }
  return __output;

}